import { useRef } from 'react';

const useCreateMarkup = () => {
  const cacheRef = useRef(new Map());

  const createMarkup = (value) => {
    const cache = cacheRef.current;
    if (!cache.has(value)) {
      cache.set(value, { __html: value });
    }
    return cache.get(value);
  };

  return { createMarkup };
};

export default useCreateMarkup;
